import { rootApi } from "../../api/rootApi";


export const smsCredentialApi = rootApi.injectEndpoints({

    endpoints: (builder) => ({
        getSmsCredentialWithLimitOffset: builder.mutation({
            query: (params) => {
              return {
                method: "GET",
                url: `/admin/smsCredential/?limit=${params.limit}&&offset=${params.offset}`,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + params.token,
                },
              };
            },
          }),
        addSmsCredential: builder.mutation({
            query: (params) => {
              return {
                method: "POST",
                url: `/admin/smsCredential/add`,
                headers: {
                  Authorization: "Bearer " + params.token,
                },
                body: params.body,
              };
            },
          }),
          updateSmsCredential: builder.mutation({
            query: (params) => {
              console.log("params",params);
              return {
                method: "PUT",
                url: `/admin/smsCredential/${params.id}`,
                headers: {
                  Authorization: "Bearer " + params.token,
                },
                body: params.body,
              };
            },
          }),
          updateSmsCredentialStatus: builder.mutation({
            query: (params) => {
              console.log("params",params);
              return {
                method: "PATCH",
                url: `/admin/smsCredential/${params.id}`,
                headers: {
                  Authorization: "Bearer " + params.token,
                },
                body: params.body,
              };
            },
          }),
        deleteSmsCredential: builder.mutation({
            query: (params) => {
              return {
                method: "DELETE",
                url: `/admin/smsCredential/${params.id}`,
                headers: {
                  Authorization: "Bearer " + params.token,
                },              };
            },
          }),
        
    })

});
export const { useAddSmsCredentialMutation , useGetSmsCredentialWithLimitOffsetMutation ,useDeleteSmsCredentialMutation , useUpdateSmsCredentialMutation , useUpdateSmsCredentialStatusMutation} = smsCredentialApi;